
import styles from "./SearchCrawlerBulkUpload.module.css";
import Select from 'react-select';
import { Form, Button, Spinner, Modal} from "react-bootstrap";
import Papa from 'papaparse';
import { useEffect, useState } from "react";
import AGTable from "../../../../components/AGTable/AGTable";
import TimedAlert from "../../../../components/TimedAlert/TimedAlert";
import { kickoffBulkSearchCrawl } from "../../../../api/portalApi";

const SearchCrawlerBulkUpload = (props) => {

    // Data State
    const [searchJobs, setSearchJobs] = useState();
    const [client, setClient] = useState();
    const [dataSource, setDataSource] = useState();
    const [tag, setTag] = useState();
    const [error, setError] = useState();
    const [alert, setAlert] = useState();

    // UI State
    const [showAlert, setShowAlert] = useState(false);
    const [showKickoffModal, setShowKickoffModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const userEmail = props.userEmail;
    const setActiveKey = props.setActiveKey;

    const clientOptions = [
        {
            'value': 'Bunnings',
            'label': 'Bunnings'
        },
        {
            'value': 'SRG',
            'label': 'SRG'
        },
        {
            'value': 'Reward Hospitality',
            'label': 'Reward Hospitality'
        }
    ];
    const dataSourceOptions = [
        {
            'value': 'Legacy',
            'label': 'Legacy'
        },
        // {
        //     'value': 'Bedrock',
        //     'label': 'Bedrock'
        // }
    ];

    useEffect(() => {
        if (!showAlert){
            setError();
        }
    }, [showAlert]);

    const handleUploadFile = (e) => {
        setSearchJobs();
        const file = e.target.files[0];
        if (!file) return;

        // 1. More robust type checking
        const isCSV = file.type === "text/csv" || file.name.endsWith('.csv');
        const isJSON = file.type === "application/json" || file.name.endsWith('.json');

        const reader = new FileReader();

        reader.onload = (event) => {
            const text = event.target.result;
            let data = null;

            try {
                if (isCSV) {
                    const parsed = Papa.parse(text, {
                        header: true,
                        skipEmptyLines: true,
                    });
                    data = parsed.data;
                } else if (isJSON) {
                    data = JSON.parse(text);
                }

                if (data && Array.isArray(data)) {
                    const formattedData = data.map(({ _type, ...rest }) => ({ ...rest }));
                    setSearchJobs(formattedData);
                }
            } catch (err) {
                console.error("Error parsing file content:", err);
            }
        };

        reader.readAsText(file);
    };

    const kickoffJobs = async() => {
        setLoading(true);
        try{
            const data = searchJobs.map((job) => {
                return {
                    ...job,
                    client: client?.label,
                    data_source: dataSource?.label,
                    tag: tag,
                    created_by: userEmail
                }
            });
            await kickoffBulkSearchCrawl(data);
            setActiveKey('kickedOffJobs');
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    };

    const handleKickoff = () => {
        setShowKickoffModal(false);
        kickoffJobs();
    };

    return (
        
        <div> 
            <Modal show={showKickoffModal}>
                <Modal.Header closeButton onClick={() => setShowKickoffModal(false)}>
                    <Modal.Title>Kickoff {searchJobs?.length} Search Crawls?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{display: 'grid'}}>

                    {!client && <span>Client must be selected</span>}
                    {!dataSource && <span>Data Source must be selected</span>}
                    {dataSource && client &&  <span>Ready to Kickoff</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowKickoffModal(false)}>
                    Close
                </Button>
                { client && dataSource &&
                    <Button variant="success" onClick={handleKickoff}>
                        Kickoff Jobs
                    </Button>
                }
                </Modal.Footer>
            </Modal>
            <TimedAlert
                message={alert}
                duration={2000}
                variant={error ? "danger" : "success"}
                show={showAlert}
                onClose={() => setShowAlert(false)}

            />
            {!loading && <div className={styles.SearchCrawlerBulkUpload}>
                <h4>Search Crawler Bulk Kickoff</h4>
                <div className={styles.BulkUploadForm}>
                    <div style={{flex:1}}>

                        <Select options={clientOptions} placeholder='Select Client' onChange={setClient}/>
                    </div>
                    <div style={{flex:1}}>
                        <Select options={dataSourceOptions} placeholder='Select Data Source' onChange={setDataSource}/>
                    </div>
                    <div style={{flex:1}}>
                        <Form.Control type="text" placeholder="Describe the job" onChange={(e) => setTag(e.target.value)}/>
                    </div>
                    <div style={{flex:1}}>
                        <Form.Control type="file" placeholder="Upload Bulk" onChange={handleUploadFile}/>
                    </div>

                    <Button variant="secondary" as="a" href="/searchCrawlBulkUpload.csv" download>Download Template</Button>
                    <Button variant="secondary" onClick={() => setShowKickoffModal(true)} disabled={!searchJobs}>Kickoff Jobs</Button>
                </div>
                {searchJobs && <AGTable data={searchJobs} editableFields={[...new Set(searchJobs.flatMap(obj => Object.keys(obj)))]}/>}
            </div>}
            {loading && <div className={styles.spinnerContainer}>
                <Spinner/>
            </div>}
        </div>

    )
};

export default SearchCrawlerBulkUpload;